var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Edit_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#78AA47;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Edit",
    className: "st0",
    d: "M9.2,19.9v2.8h2.8l8.3-8.3l-2.8-2.8L9.2,19.9z M22.5,12.3c0.3-0.3,0.3-0.8,0-1.1c0,0,0,0,0,0 l-1.8-1.8c-0.3-0.3-0.8-0.3-1.1,0c0,0,0,0,0,0l-1.4,1.4l2.8,2.8L22.5,12.3L22.5,12.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.3ea294ca3439893e023279ff9a819c46.svg";
export { ForwardRef as ReactComponent };